export const ACCESS_LEVEL_UNSPECIFIED = 'ACCESS_LEVEL_UNSPECIFIED';
export const ACCESS_LEVEL_VIEW_POOL_MINING = 'ACCESS_LEVEL_VIEW_POOL_MINING';
export const ACCESS_LEVEL_VIEW_POOL_ALL = 'ACCESS_LEVEL_VIEW_POOL_ALL';

export const ALL_ACL = [
  ACCESS_LEVEL_UNSPECIFIED,
  ACCESS_LEVEL_VIEW_POOL_MINING,
  ACCESS_LEVEL_VIEW_POOL_ALL,
];
